export enum GeneralLicenseStatus {
  NONE = 0,
  ENABLED = 1,
  DISABLED = 2
}

export enum ExtruderLevel {
  NONE = 0,
  BASE = 1,
  DESIGNER = 2,
  RESELLER = 3,
  FABRICATOR = 4
}

export const ApplicationStatus = {
  PENDING: { id: 0, label: 'Pending' },
  VERIFIED: { id: 1, label: 'Verified' },
  ACCEPTED: { id: 2, label: 'Accepted' },
  DECLINED: { id: 3, label: 'Declined' }
} as const

export type ApplicationStatus = (typeof ApplicationStatus)[keyof typeof ApplicationStatus]

export const ApplicationStatusById = Object.fromEntries(
  Object.values(ApplicationStatus).map((status) => [status.id, status])
) as Record<ApplicationStatus['id'], ApplicationStatus>

export enum LicenseStatusType {
  None = 0,
  ENABLED = 1,
  DISABLED = 2
}
